import { NgModule } from "@angular/core";
import { ElectronicSignatureFormComponent } from './electronic-signature-form/electronic-signature-form.component';
import { DynamicElectronicSignatureComponent } from './dynamic-electronic-signature.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { ElectronicSignatureDesignComponent } from './electronic-signature-design/electronic-signature-design.component';
import { ElectronicSignatureResultComponent } from './electronic-signature-result/electronic-signature-result.component';

@NgModule({
    declarations: [
        ElectronicSignatureResultComponent,
        ElectronicSignatureDesignComponent,
        ElectronicSignatureFormComponent, DynamicElectronicSignatureComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        IonicModule
    ],
    entryComponents: [
        DynamicElectronicSignatureComponent
    ]
})
export class ElectronicSignatureModule {}